import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, input } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatPrefix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { Router } from '@angular/router';
import { FromDictionaryPipe, LanguageService } from '@teamfoster/sdk/dictionary-ngrx';
import { IconComponent } from '@teamfoster/sdk/icon';
import { debounceTime, distinctUntilChanged } from 'rxjs';

@Component({
  selector: 'app-library-search-field',
  imports: [MatFormField, ReactiveFormsModule, FormsModule, MatInput, IconComponent, MatPrefix, FromDictionaryPipe],
  templateUrl: './library-search-field.component.html',
  styleUrl: './library-search-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LibrarySearchFieldComponent implements AfterViewInit {
  initialQuery = input<string>('');

  fb = inject(FormBuilder);
  router = inject(Router);
  cd = inject(ChangeDetectorRef);
  private langService = inject(LanguageService);
  dict = new FromDictionaryPipe(this.langService);

  searchForm = this.fb.group({
    query: this.fb.control<string>(''),
  });

  ngAfterViewInit(): void {
    this.searchForm.patchValue({ query: this.initialQuery() });
    this.cd.detectChanges();
  }

  onSubmit(): void {
    const dictionaryUrl =
      this.dict.transform('bibliotheek_zoek_url', false) || 'https://catalogus.coda-apeldoorn.nl/iguana/www.main.cls?surl=CA_Search';

    // go to external site in new tab
    window.open(`${dictionaryUrl}#searchterm=${this.searchForm?.value?.query}`, '_blank');
  }
}
